document.addEventListener('DOMContentLoaded', function () {
    /* Experience Section */
    const experienceSection = document.querySelector(".experience-section");

    const carouselContainer = experienceSection.querySelector(".carousel-container");
    const carouselColumns = carouselContainer.querySelectorAll(".column");
    const carouselMainColumns = carouselContainer.querySelectorAll(".main-column");

    const leftArrow = experienceSection.querySelector(".left-arrow");
    const rightArrow = experienceSection.querySelector(".right-arrow");

    const carouselDots = experienceSection.querySelectorAll('.dot');

    let carouselIndex = 0;
    carouselDots[0].classList.add("active");

    scrollAmount = carouselContainer.scrollWidth / carouselColumns.length;
    carouselContainer.scrollLeft += scrollAmount * 2;

    leftArrow.addEventListener("click", function() {
        scrollAmount = carouselContainer.scrollWidth / carouselColumns.length;
        carouselContainer.scrollLeft -= scrollAmount;

        experienceSection.querySelector('.dot.active').classList.remove("active");

        if (carouselIndex <= 0) {
            leftArrow.style.pointerEvents = "none";
            rightArrow.style.pointerEvents = "none";
            setTimeout(() => {
                carouselContainer.style.scrollBehavior = 'auto'; 
                carouselContainer.scrollLeft = scrollAmount * (carouselColumns.length - 6);
                carouselContainer.style.scrollBehavior = 'smooth'; 
                leftArrow.style.pointerEvents = "unset";
                rightArrow.style.pointerEvents = "unset";

                carouselIndex = carouselMainColumns.length - 1;
                carouselDots[carouselIndex].classList.add("active");
            }, 400);
        }
        else {
            carouselIndex--;
            carouselDots[carouselIndex].classList.add("active");
        }
    });
    rightArrow.addEventListener("click", function() {
        scrollAmount = carouselContainer.scrollWidth / carouselColumns.length;
        carouselContainer.scrollLeft += scrollAmount;

        experienceSection.querySelector('.dot.active').classList.remove("active");

        if (carouselIndex >= carouselMainColumns.length - 1) {
            leftArrow.style.pointerEvents = "none";
            rightArrow.style.pointerEvents = "none";
            setTimeout(() => {
                carouselContainer.style.scrollBehavior = 'auto'; 
                carouselContainer.scrollLeft = scrollAmount * 2;
                carouselContainer.style.scrollBehavior = 'smooth'; 
                rightArrow.style.pointerEvents = "unset";
                leftArrow.style.pointerEvents = "unset";

                carouselIndex = 0;
                carouselDots[carouselIndex].classList.add("active");
            }, 400);
        }
        else {
            carouselIndex++;
            carouselDots[carouselIndex].classList.add("active");
        }
    });

    // Dots handler
    for (let i = 0; i < carouselDots.length; i++) {
        carouselDots[i].addEventListener("click", function() {
            experienceSection.querySelector('.dot.active').classList.remove("active");
            this.classList.add("active");

            scrollAmount = carouselContainer.scrollWidth / carouselColumns.length;
            carouselContainer.scrollLeft = scrollAmount * (i + 2);
        });
    }

    /* End Experience Section */
});